import styled from 'styled-components';

export const ModalCrossbtn = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 9;
  background-size: cover;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const PopupContainer = styled.div`
  background: #fff;
  h4 {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: bold;
    margin-bottom: 16px;
  }

  .heading {
    padding: 20px 20px 0 20px;
    text-align: center;
    h5 {
      font-weight: 500;
      text-align: center;
      padding: 10px;
    }
  }
`;

export const FormContainer = styled.div`
  margin-bottom: 20px;
`;

export const FloatLabelDiv = styled.div`
  position: relative;
  padding: ${(props) => (props.refundCallback ? '0 0 10px' : '20px 0 0')};
  align-items: center;
  grid-gap: 16px;
  position: relative;
  h2 {
    font-size: 16px;
    width: 90%;
    margin: 14px auto;
    color: rgba(0, 0, 0, 0.8);
  }
`;

export const FloatInput = styled.input`
  border: ${(props) =>
    props.hasError
      ? '1px solid #ef4e5ebb'
      : '1px solid hsl(0deg, 0%, 0%, 18%)'};
  border-radius: 6px;
  outline: none;
  width: 90%;
  padding: 0px 16px;
  height: 50px;
  font-size: 12px;
  font-family: Montserrat;
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 500;
  margin: 0px auto;
  display: block;
  pointer-events: auto;
  &:focus {
    border: ${(props) =>
      props.hasError ? '1px solid #ef4e5ebb' : '1px solid #63b0a8'};
  }
`;

export const CallbackButton = styled.button`
  width: 100%;
  padding: 14px 0;
  font-size: 16px;
  color: #fff;
  background: #ef4e5e;
  font-weight: 600;
  border: none;
  &:disabled {
    background: #ef4e5ebb;
    pointer-events: none;
  }
  font-family: Montserrat;
`;

export const ErrorMsg = styled.div`
  color: #ef4e5e;
  font-size: 10px;
  padding-left: 30px;
  margin-top: 5px;
`;
